import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

export type PixelVisibleApp = {
	appKey: string;
	isAuthenticated: boolean | null;
};

type SearchPageFiltersViewedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	visibleApps: PixelVisibleApp[];
};

export const onSearchPageFiltersViewed = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	visibleApps,
}: SearchPageFiltersViewedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'searchPageFilters',
	action: 'viewed',
	attributes: {
		additionalAttributes: {
			visibleApps,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
